import { Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import { AlertControlService } from '../../services/alert-control.service';
import { Subscription } from 'rxjs/Subscription';
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.sass']
})
export class AlertComponent implements OnInit, OnDestroy {

  @Input() class = '';
  @Input() text = '';
  @Input() icon = '';
  @Input() status = '';
  @Input() param = null;
  @Input() fixed = false; // si es true, la alerta no debe desaparecer automáticamente
  public show = false;
  public selectAlert: any;
  public subscriptionAlert: Subscription;
  public timer: any;
  constructor(
    public _alertControlService: AlertControlService
  ) { }

  ngOnInit() {
    this.selectAlert = '';
    this.subscriptionAlert = this._alertControlService.observableAlertShow$
      .subscribe((res: any) => {
        if (res) {
          if (res.close) {
            this.close();
          } else {
            this.status = res.status;
            this.text = res.message;
            this.param = res.param ? res.param : null;
            this.fixed = res.fixed ? res.fixed : false;
            this.show = true;
            this.alertConfig();
          }
        }
      });
  }

  close() {
    this._alertControlService._showAlertResouce.next(null);
    this.show = false;
    clearTimeout(this.timer);
  }

  ngOnDestroy() {
    this.subscriptionAlert.unsubscribe();
    clearTimeout(this.timer);
  }

  alertConfig() {
    this.selectAlert = null;
    $('.alert-animated').fadeIn();
    const alertTypes = [
      {
        status: 'success',
        text: this.text,
        icon: 'fa fa-check-circle',
        class: 'alert-success',
        param: this.param,
      },
      {
        status: 'danger',
        text: this.text,
        icon: 'fa fa-exclamation-circle',
        class: 'alert-danger',
        param: this.param,
      },
      {
        status: 'warning',
        text: this.text,
        icon: 'fa fa-exclamation-triangle',
        class: 'alert-warning',
        param: this.param,
      },
      {
        status: 'info',
        text: this.text,
        icon: 'fa fa-info-circle',
        class: 'alert-info',
        param: this.param,
      },
      {
        status: 'other',
        text: this.text,
        icon: this.icon,
        class: this.class,
        param: this.param,
      }
    ];
    this.selectAlert = alertTypes.find(x => x.status === this.status);
    if (!this.fixed) {
      this.timer = setTimeout(() => {
        $('.alert-animated').fadeOut(1200, 'linear');
      }, 5000);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/alert/alert.component.ts